import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-punto-pago',
  templateUrl: './punto-pago.component.html',
  styleUrls: ['./punto-pago.component.css']
})
export class PuntoPagoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
